import { Button, Modal } from 'antd';
import React, { Component } from 'react';
import styles from './PlatformConnectionModal.module.scss';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import CustomContext from '../../../context/CustomContext';
import { Link } from 'react-router-dom';

class PlatformConnectionModal extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;
    readonly notificationKey = 'PreConnector.WorkDocsConnectionNotification';

    constructor(props: Props) {
        super(props);
        this.state = {
            visible: false,
        };
    }

    componentDidMount() {
        if (localStorage.getItem(this.notificationKey) !== 'true') {
            localStorage.setItem(this.notificationKey, 'true');
            this.setState({ visible: true });
        }
    }

    cancel = () => {
        this.setState({ visible: false });
    };

    render() {
        const { visible } = this.state;

        return (
            <Modal
                title={<FormattedMessage id="home.platformConnection.title" />}
                visible={visible}
                footer={[
                    <Button key="cancel" onClick={this.cancel} className={styles.cancel}>
                        <FormattedMessage id="button.close" />
                    </Button>,
                    <Link key="ok" to="/settings">
                        <Button type="primary">
                            <FormattedMessage id="button.connect" />
                        </Button>
                    </Link>,
                ]}
            >
                <FormattedMessage id="home.platformConnection.description" />
            </Modal>
        );
    }
}
export default injectIntl(PlatformConnectionModal);

interface Props extends WrappedComponentProps {}

interface State {
    visible: boolean;
}
